<template>

  <article class="c-article__title">
    <h2>{{ content.title }}</h2>
  </article>

</template>

<script>
export default {
  name: 'Title',
  props: ['content'],

  methods: {
  }

}
</script>
